<div
  rtReportTooltipOutlet
  [rtResizeObserver]="{ initial: true }"
  (resized)="size$.next({ width: $event.width, height: $event.height })"
  #chartOutlet
  layout
></div>
